module.exports = __webpack_public_path__ + "img/ttl02e.03b392d6.png";